import './Modal.scss';

const Modal = ({isOpen, children}) => isOpen ? (
    <div className="modal-component">
        {children}
    </div>
) : null;

export default Modal;